import { render, staticRenderFns } from "./PerformanceMetricsVisualization.vue?vue&type=template&id=20c51238&"
import script from "./PerformanceMetricsVisualization.vue?vue&type=script&lang=js&"
export * from "./PerformanceMetricsVisualization.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceMetricsVisualization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports